import React, { useState } from "react";
import { Form, Input, Button, Card, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { API_BASE } from "../../config/api";
import { getAuthHeaders } from "../../utils/auth";

const CreateCategory = ({onSuccess}) => {
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", values.name);

      if (fileList.length > 0) {
        formData.append("image", fileList[0].originFileObj);
      }

      await axios.post(`${API_BASE}/category`, formData, {
        headers: getAuthHeaders({ "Content-Type": "multipart/form-data" }),
      });

      message.success("Categoría creada correctamente");
      setFileList([]);
      form.resetFields();
      onSuccess();
    } catch (err) {
      console.error(err);
      message.error("Error creando la categoría");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = ({ fileList: newList }) => {
    setFileList(newList);
  };

  return (
    <Card  style={{ maxWidth: 500, margin: "auto" }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>

        {/* Nombre */}
        <Form.Item
          label="Nombre de la categoría"
          name="name"
          rules={[{ required: true, message: "Ingrese el nombre" }]}
        >
          <Input placeholder="Ej: Corte de Pelo" />
        </Form.Item>

        {/* Imagen con vista previa */}
        <Form.Item label="Imagen">
          <Upload
            listType="picture-card"       // Miniatura
            fileList={fileList}
            onChange={handleChange}
            beforeUpload={() => false}    // previene upload automático
            onRemove={() => setFileList([])}
            maxCount={1}
          >
            {fileList.length >= 1 ? null : (
              <div>
                <UploadOutlined />
                <div style={{ marginTop: 8 }}>Subir</div>
              </div>
            )}
          </Upload>
        </Form.Item>

        {/* Botón */}
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Crear Categoría
          </Button>
        </Form.Item>

      </Form>
    </Card>
  );
};

export default CreateCategory;
